/**
 * Break out of the embedded-app iframe and navigate the TOP-level browser
 * window.
 *
 * Shopify's Billing `confirmationUrl` is a merchant-admin approval page that
 * must not load inside our iframe (X-Frame-Options / nested-admin issues).
 * App Bridge v4's Navigation API uses `open(url, "_top")` to leave the
 * embedded iframe. Shopify can intercept that call and perform the navigation
 * in the Admin shell; a direct cross-origin `window.top.location` assignment
 * cannot rely on that contract.
 *
 * `_top` also targets the current top-level browsing context when the app is
 * opened standalone, so no separate development fallback is needed.
 */
export function redirectTopLevel(url: string): void {
  window.open(url, "_top");
}
